// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal-2F6LF","closeIcon":"closeIcon-3NPqp"};